import type { RuleFormValues } from './ruleFormSchema';

export const areConditionsEqual = (
  a: RuleFormValues['conditions'],
  b: RuleFormValues['conditions'],
) =>
  a.length === b.length &&
  a.every(
    (condition, index) =>
      condition.property === b[index]?.property &&
      condition.operator === b[index]?.operator &&
      condition.regex === b[index]?.regex,
  );
